<template>
  <div>
    <search
      :show-by-address="searchDisplays.byAddress"
      :show-by-coordinate="searchDisplays.byCoordinate"
      :show-by-my-location="searchDisplays.byMyLocation"
      class="fixed-top m-3 m-xl-4 pointer-events-none"
    />
    <leaflet-map
      :calling-system="callingSystem"
      :coordinate="coordinate"
      :fault-groups="coverageFaultGroups"
      :show-coverage-info="coverageInfoDisplay"
      :group="coverageGroup"
      :product="$route.query.product"
      :link-target="linkTargetMode"
    />
    <map-base-selector
      class="fixed-bottom m-xl-3 m-3 mb-3 mb-xl-4 pointer-events-all"
      v-show="mapBaseSelectorDisplay"
      :current-map-type="baseLayer"
    />
    <coverage-layer-selector
      class="fixed-bottom pointer-events-none m-xl-3 m-3 mb-xl-4"
      v-show="layerGroupDisplay"
      :layers="coverageLayerConfig"
    />
    <div
      class="modal fade"
      id="logFaultModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title"
              id="exampleModalLongTitle"
            >
              Log a fault
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form
              @submit.prevent="validateBeforeSubmit"
              method="POST"
            >
              <div class="form-group">
                <input
                  name="Name"
                  v-model="logFault.names"
                  type="text"
                  class="form-control"
                  placeholder="Your names"
                  v-validate="nameValidation"
                >
                <span class="validation-text text-danger">{{ errors.first('Name') }}</span>
              </div>
              <div class="form-group">
                <select
                  name="FaultType"
                  v-validate="faultTypeValidation"
                  v-model="logFault.faultType"
                  class="form-control"
                >
                  <option
                    value=""
                    selected
                    disabled
                  >
                    Fault type
                  </option>
                  <option>A dropped call</option>
                  <option>Bad reception</option>
                  <option>Poor data coverage</option>
                </select>
                <span class="validation-text text-danger">{{ errors.first('FaultType') }}</span>
              </div>

              <div class="form-group">
                <select
                  name="FaultLocale"
                  v-model="logFault.faultLocale"
                  v-validate="faultLocaleValidation"
                  class="form-control"
                >
                  <option
                    value=""
                    selected
                    disabled
                  >
                    Where did you encounter the fault?
                  </option>
                  <option>Indoors</option>
                  <option>Outdoors</option>
                  <option>While Driving</option>
                </select>
                <span class="validation-text text-danger">{{ errors.first('FaultLocale') }}</span>
              </div>
              <div class="form-group">
                <select
                  name="NumbersAffected"
                  v-validate="numbersAffectedValidation"
                  v-model="logFault.numbersAffected"
                  class="form-control"
                >
                  <option
                    value=""
                    selected
                    disabled
                  >
                    How many numbers affected?
                  </option>
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>More than 3</option>
                </select>
                <span class="validation-text text-danger">
                  {{ errors.first('NumbersAffected') }}
                </span>
              </div>
              <div class="form-group">
                <select
                  name="ProblemDuration"
                  v-validate="problemDurationValidation"
                  v-model="logFault.problemDuration"
                  class="form-control"
                >
                  <option
                    value=""
                    selected
                    disabled
                  >
                    Duration of the problem
                  </option>
                  <option>Less than 1 week</option>
                  <option>Less than 3 weeks</option>
                  <option>More than 3 weeks</option>
                </select>
                <span class="validation-text text-danger">
                  {{ errors.first('ProblemDuration') }}
                </span>
              </div>
              <div class="form-group">
                <textarea
                  v-model="logFault.comment"
                  class="form-control"
                  placeholder="Additional comments"
                />
              </div>

              <div class="form-group">
                <input
                  name="Phone"
                  v-validate="phoneValidationRule"
                  v-model="logFault.phone"
                  type="text"
                  placeholder="Your phone no"
                  class="form-control"
                >
                <span class="validation-text text-danger">{{ errors.first('Phone') }}</span>
              </div>
              <div class="form-group">
                <input
                  name="CellNumberAlternative"
                  v-validate="cellNumberAlternativeValidationRule"
                  v-model="logFault.cellNumberAlternative"
                  type="text"
                  placeholder="Alternative phone no"
                  class="form-control"
                >
                <span class="validation-text text-danger">
                  {{ errors.first('CellNumberAlternative') }}
                </span>
              </div>

              <div class="form-group">
                <input
                  name="Email"
                  v-model="logFault.email"
                  v-validate="emailValidation"
                  type="email"
                  placeholder="Your email"
                  class="form-control"
                >
                <span class="validation-text text-danger">
                  {{ errors.first('Email') }}
                </span>
              </div>
              <div class="form-group">
                <label class="mr-5">Preferred contact method: </label>

                <input
                  type="radio"
                  name="preferredcontactmethod"
                  autocomplete="off"
                  checked
                  value="SMS"
                  v-model="logFault.preferredcontactmethod"
                > SMS
                <input
                  type="radio"
                  name="preferredcontactmethod"
                  autocomplete="off"
                  value="Telephone"
                  v-model="logFault.preferredcontactmethod"
                > Telephone
                <input
                  type="radio"
                  name="preferredcontactmethod"
                  autocomplete="off"
                  value="Email"
                  v-model="logFault.preferredcontactmethod"
                > Email
              </div>
              <div class="form-group">
                <button
                  :disabled="isSubmittingFault"
                  type="submit"
                  class="btn btn-primary m-1"
                >
                  Submit
                </button>
                <button
                  type="button"
                  class="btn btn-secondary m-1"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import CoverageLayerSelector from '@/components/CoverageLayerSelector.vue';
import EventBus from '@/eventBus';
import LeafletMap from '@/components/LeafletMap.vue';
import MapBaseSelector from '@/components/MapBaseSelector.vue';
import Search from '@/components/Search.vue';

export default {
  components: {
    CoverageLayerSelector,
    LeafletMap,
    MapBaseSelector,
    Search,
  },
  computed: {
    coverageFaultGroups() {
      if (this.coverageLayerConfig == null) {
        return null;
      }
      return this.coverageLayerConfig.filter((v) => v.logCoverageFault).map((val) => val.group);
    },
    emailValidation() {
      return {
        required: this.logFault.preferredcontactmethod === 'Email',
      };
    },
  },
  data() {
    return {
      baseLayer: 'vector',
      callingSystem: null,
      coordinate: null,
      coverageGroup: this.$route.query.group,
      coverageInfoDisplay: true,
      coverageLayerConfig: [],
      faultLocaleValidation: {
        required: true,
      },
      faultTypeValidation: {
        required: true,
      },
      problemDurationValidation: {
        required: true,
      },
      numbersAffectedValidation: {
        required: true,
      },
      filterGroup: null,
      filterProduct: null,
      isSubmittingFault: false,
      logFault: {
        comment: null,
        email: null,
        faultLocale: '',
        faultType: '',
        numbersAffected: '',
        problemDuration: '',
        latitude: null,
        longitude: null,
        names: null,
        phone: null,
        cellNumberAlternative: null,
        preferredcontactmethod: 'SMS',
      },
      layerGroupDisplay: true,
      mapBaseSelectorDisplay: true,
      nameValidation: {
        required: true,
      },
      linkTargetMode: '_blank',
      phoneValidationRule: {
        required: true,
        regex: /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/,
      },
      cellNumberAlternativeValidationRule: {
        regex: /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/,
      },
      searchDisplays: {
        byAddress: true,
        byCoordinate: true,
        byMyLocation: true,
      },
      zoomLevel: null,
    };
  },
  destroyed() {
    EventBus.$off('show-modal');
  },
  methods: {
    LoadLayerConfiguration() {
      const url = `${process.env.VUE_APP_ROOT_API}/api/LayerConfiguration`;
      this.$http.get(url).then((data) => {
        this.filterGroup = this.$route.query.group;
        this.filterProduct = this.$route.query.product;

        this.coverageLayerConfig = data.body;

        if (this.filterGroup) {
          this.coverageLayerConfig = this.coverageLayerConfig
            .filter((clc) => clc.group === this.filterGroup);
        }

        if (this.filterProduct) {
          this.coverageLayerConfig.forEach((clc) => {
            const configGroup = clc;
            configGroup.layers = clc.layers.filter((l) => l.name === this.filterProduct);
          });

          this.coverageLayerConfig = this.coverageLayerConfig
            .filter((clg) => clg.layers.length > 0);
        }

        if (this.coverageLayerConfig.length) {
          this.coverageGroup = this.coverageLayerConfig[0].group;
        }

        if (!this.$route.query.coordinate) {
          return;
        }

        const coordParts = this.$route.query.coordinate.split(',');

        this.coordinate = {
          latitude: parseFloat(coordParts[1]),
          longitude: parseFloat(coordParts[0]),
        };
      });
    },
    queryStringSaysHide(param) {
      const nos = ['N', 'n'];
      return !nos.some((n) => n === param);
    },
    reportFault() {
      this.isSubmittingFault = true;
      const params = `name=${
        this.logFault.names
      }&message=${
        this.logFault.comment
      }&email=${
        this.logFault.email
      }&latitude=${
        this.logFault.latitude
      }&longitude=${
        this.logFault.longitude
      }&cellnumber=${
        this.logFault.phone
      }&cellNumberAlternative=${
        this.logFault.cellNumberAlternative
      }&faulttype=${
        this.logFault.faultType
      }&numbersaffected=${
        this.logFault.numbersAffected
      }&problemduration=${
        this.logFault.problemDuration
      }&locale=${
        this.logFault.faultLocale
      }&preferredcontactmethod=${
        this.logFault.preferredcontactmethod
      }`;

      const url = `${process.env.VUE_APP_ROOT_API}/api/LogAFault?${params}`;

      this.$http.get(url).then((result) => {
        try {
          if (result.status !== 200) {
            return;
          }
          // eslint-disable-next-line
          $('#logFaultModal').modal('hide');
        } finally {
          this.isSubmittingFault = false;
        }
      });
    },
    showModal(address) {
      this.logFault.latitude = address.latitude;
      this.logFault.longitude = address.longitude;
      // eslint-disable-next-line
      $('#logFaultModal').modal('show');
    },
    validateBeforeSubmit() {
      this.$validator
        .validateAll()
        .then((response) => {
          // Validation success if response is true
          if (!response) {
            return;
          }
          this.reportFault();
        })
        .catch(() => {
          // Catch errors
        });
    },
  },
  mounted() {
    this.coverageInfoDisplay = this.queryStringSaysHide(this.$route.query.coverageInfo);
    this.layerGroupDisplay = this.queryStringSaysHide(this.$route.query.layerGroup);
    this.mapBaseSelectorDisplay = this.queryStringSaysHide(this.$route.query.basemapToggle);
    this.searchDisplays.byCoordinate = this.queryStringSaysHide(this.$route.query.locationCoord);
    this.searchDisplays.byAddress = this.queryStringSaysHide(this.$route.query.locationAddress);
    this.searchDisplays.byMyLocation = this.queryStringSaysHide(this.$route.query.locationMy);
    EventBus.$on('show-modal', this.showModal);

    if (this.$route.query.openLinksInSelf === 'true') {
      this.linkTargetMode = '_self';
    }

    if (this.$route.query.baseLayer) {
      this.baseLayer = this.$route.query.baseLayer;
    }
    this.callingSystem = this.$route.query.callingSystem;
    this.LoadLayerConfiguration();
    this.$nextTick(() => {
      const dict = {
        custom: {
          Name: {
            required: 'This field is required.',
          },
          FaultType: {
            required: 'This field is required.',
          },
          NumbersAffected: {
            required: 'This field is required.',
          },
          ProblemDuration: {
            required: 'This field is required.',
          },
          FaultLocale: {
            required: 'This field is required.',
          },
          Phone: {
            Phone: 'Enter a valid phone no',
            required: 'This field is required.',
          },
          Email: {
            required: 'This field is required.',
          },
        },
      };
      this.$validator.localize('en', dict);
    });
  },
};
</script>
<style>
.pointer-events-none {
  pointer-events: none;
  cursor: alias;
}
</style>
